<template>
    <div class="toggle-subject pb-2">
        <label
            class="toggle-switch font-weight-bold toggle-switch__subject mb-0"
        >
            <input
                v-model="subscription.isSubscribed"
                class="toggle-switch__input"
                type="checkbox"
                @click="changeSubjectSubscription"
            />
            <span class="toggle-switch__slider"></span>
            {{ subscription.name }}
        </label>
        <div class="flex-break"></div>
        <div class="w-100 d-flex flex-wrap">
            <toggle-legislation
                v-for="(legislation, index) in subscription.items"
                :key="index"
                :legislation="legislation"
            ></toggle-legislation>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import toggleLegislation from '@/components/form/toggle-legislation';
export default {
    components: {
        toggleLegislation
    },
    props: {
        subscription: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    methods: {
        changeSubjectSubscription() {
            if (this.subscription.isSubscribed) {
                const url =
                    '/umbraco/api/legislation/unsubscribeFromLegislationSubject';
                Axios({
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: this.subscription.id
                }).then(response => {
                    this.subscription.items = response.data.items;
                });
            } else {
                const url =
                    '/umbraco/api/legislation/subscribeToLegislationSubject';
                Axios({
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: this.subscription.id
                }).then(response => {
                    this.subscription.items = response.data.items;
                });
            }
        }
    }
};
</script>

<style lang="scss">
.toggle-subject {
    margin-bottom: 1rem;
    border-bottom: 1px solid $brand-gray;
}

.toggle-child__switch {
    padding-left: 20px;
}
</style>
